{
  "fr": {
    "courseCatalog": {
      "activeCourses": {
        "title": "Formations actives",
        "toCourse": "Aller au cours"
      },
      "headers": {
        "title": "Découvrez des formations pratiques",
        "subtitle": "Que souhaitez-vous apprendre aujourd'hui ?"
      },
      "filters": {
        "courseType": "Type de cours",
        "subjectAreas": "Domaines thématiques",
        "languages": "Langue",
        "order": {
          "label": "Tri",
          "relevant": "Pertinence",
          "mostRecent": "Les plus récents",
          "rating": "Évaluation",
          "popular": "Popularité"
        }
      },
      "courseTypes": {
        "courses": "Formations",
        "webinar": "Webinaires en direct",
        "recording": "Enregistrements",
        "impulse": "Impulsions"
      },
      "sections": {
        "liveWebinars": "Webinaires en direct",
        "liveWebinarsDescription": "Participez à des conférences d'experts avec des espaces de discussion et la possibilité d'échanger.",
        "newCourses": "Nouveaux cours",
        "pinned": "Favoris fobizz",
        "pinnedDescription": "Cours particulièrement populaires et pertinents - les recommandations actuelles de la rédaction fobizz.",
        "impulses": "Impulsions",
        "impulsesDescription": "Recevez des aperçus compacts et pratiques sur de nouveaux sujets et idées de cours - en moins de 30 minutes.",
        "courses": "Formations",
        "coursesDescription": "Apprenez à votre rythme, quand et où vous voulez - suivez des cours en auto-apprentissage avec un fort lien pratique.",
        "recommendations": "Recommandations de cours personnalisées",
        "recommendationsDescription": "Une sélection de cours particulièrement pertinents pour vous, basée sur votre profil et les cours que vous avez déjà suivis ou enregistrés.",
        "recordings": "Enregistrements de webinaires",
        "recordingsDescription": "Suivez les webinaires en direct passés grâce aux enregistrements et approfondissez vos connaissances en toute flexibilité."
      },
      "links": {
        "showAllWebinars": "Afficher tous les webinaires en direct",
        "showAllCourses": "Afficher toutes les formations",
        "showAllImpulses": "Afficher toutes les impulsions",
        "showAllRecordings": "Afficher tous les enregistrements de webinaires"
      },
      "search": {
        "placeholder": "Rechercher des formations...",
        "noResults": "Malheureusement, nous n'avons trouvé aucun cours correspondant à ces critères de recherche."
      },
      "subjectAreas": {
        "subject_area_didactic": "Didactique et conception de cours",
        "subject_area_media_education": "Compétence et critique des médias",
        "subject_area_collaboration": "Travail d'équipe et relations",
        "subject_area_school_development": "Développement scolaire et leadership",
        "subject_area_performance": "Performance, feedback et niveau d'apprentissage",
        "subject_area_diversity": "Inclusion, différenciation et éducation linguistique",
        "subject_area_health": "Santé et professionnalisation",
        "subject_area_ki": "Intelligence artificielle",
        "subject_area_tools": "Outils et applications numériques",
        "subject_area_kids_world": "Univers des élèves et société",
        "subject_area_chances": "Chances de départ",
        "subject_area_programming": "Programmation et informatique"
      },
      "teaser": {
        "title": "Recevez des recommandations de formations individuelles",
        "linkName": "Vers le chercheur de formations IA"
      },
      "languages": {
        "de": "Allemand",
        "en": "Anglais",
        "fr": "Français",
        "es": "Espagnol"
      }
    }
  }
}
